module.exports = __webpack_public_path__ + "img/h2o-excretion.ae40c9e3.svg";